import { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';
import { AUTH_API_URL } from '../api/config';

export function useAuth() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('userInfo');
    if (saved) {
      try { setCurrentUser(JSON.parse(saved)); } catch (e) { console.error(e); }
    }
    const handleAuthRequired = () => {
      setCurrentUser(null);
      window.dispatchEvent(new CustomEvent('navigate', { detail: 'login' }));
    };
    window.addEventListener('auth-required', handleAuthRequired);
    return () => window.removeEventListener('auth-required', handleAuthRequired);
  }, []);

  const userRole = currentUser?.role || localStorage.getItem('userRole') || 'recruitment';
  const canAdd = userRole !== 'sales';
  const canEdit = userRole !== 'sales';

  const handleLoginSuccess = (userInfo) => {
    setCurrentUser(userInfo);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    localStorage.setItem('userRole', userInfo.role || 'recruitment');
  };

  const handleLogout = async () => {
    try { await axios.get(`${AUTH_API_URL}/logout`); } catch (e) { console.error(e); }
    localStorage.removeItem('userInfo');
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    setCurrentUser(null);
  };

  return { currentUser, userRole, canAdd, canEdit, handleLoginSuccess, handleLogout, setCurrentUser };
}